import { ContentfulCategoryPageQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

import { useCuratedCategoryPageRelatedCarouselsQuery } from "../../../hooks/useCuratedCategoryPageQuery";
import JumpPillsCarousel from "../basic/JumpPillsCarousel";

type ContentfulCategoryPage =
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  ContentfulCategoryPageQuery["contentfulCategoryPageCollection"]["items"][0];

export default function CuratedCategoryJumpPillsCarousel({
  data,
  page,
  categoryName
}: {
  data: ReturnType<typeof useCuratedCategoryPageRelatedCarouselsQuery>["data"];
  page?: ContentfulCategoryPage;
  categoryName?: string;
}) {
  const { t } = useTranslation(
    "client\\components\\categories\\CuratedCategoryJumpPillsCarousels"
  );

  const relatedCarousels =
    data?.contentfulCategoryPageCollection?.items[0]
      ?.relatedCategoriesCollection?.items;

  if (!data || relatedCarousels?.length === 0) {
    return <Space y={"94px"} />;
  }

  const title =
    page?.jumpPillsTitle ??
    t("Top-rated {{categoryName}} classes and tutors", {
      categoryName
    });

  const jumpPillsData = page.jumpPillLinksCollection.items.map(
    (el: $TSFixMe) => ({
      name: el.text,
      path: el.path
    })
  );

  const carouselsData =
    relatedCarousels &&
    relatedCarousels
      // @ts-ignore TS(2531): Object is possibly 'null'.
      .filter(el => el.title != null && el.callToActionUrl != null)
      .map(el => ({
        // @ts-ignore TS(2531): Object is possibly 'null'.
        name: el.title,
        // @ts-ignore TS(2531): Object is possibly 'null'.
        path: el.callToActionUrl
      }));

  const pillsData = jumpPillsData.length > 0 ? jumpPillsData : carouselsData;

  return <JumpPillsCarousel pillsData={pillsData} title={title} />;
}
